<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <div class="trinka_cloud_banner_text">
                        <span>
                            <img src="../../../../assets/images/credits_icon.png" style="width: 15px;margin-right: 5px;" />Créditos em Trinka</span>
                        <h1>Flexibilidade para usar os recursos de Trinka do jeito que você precisa
                        </h1>
                        <p>Os créditos são como tokens que oferecem a flexibilidade de usar diferentes recursos do Trinka conforme
                            necessário. Você também recebe créditos gratuitos todos os meses!
                        </p>
                        <a href="https://cloud.trinka.ai/signup?_rg=PT" id="autoEditGetStart" target="_blank">Iniciar</a>
                    </div>
                </div>
                <div class="col-lg-5">
                    <div class="trinka_cloud_banner_img">
                        <img src="../../../assets/images/CreditInformation.png" alt="credit info">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="cloud_key_features">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="key_features_heading">
                        <h2>Use créditos do seu recurso favorito</h2>
                        <div class="HeadingSubLine"></div>

                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="credit_feature">
                        <table class="table">
                            <thead>
                                <tr class="odd">
                                    <th>Recurso</th>
                                    <th class="text-center">
                                        <sup>
                                            <img style="width: 20px;" src="../../../../assets/images/credits_icon.png" />
                                        </sup> Créditos consumidos
                                    </th>
                                </tr>
                            </thead>
                            <tr>
                                <td>
                                    <h5>Verificação de Plágio Trinka</h5>
                                    <p>Obtenha a mais alta qualidade de verificação de plágio contra fontes da Internet e algumas publicações de Acesso Aberto, powered by iThenticate.

                                    </p>
                                </td>
                                <td>
                                    <p class="text-center" style="font-size: 16px;">12 créditos por relatório
                                    </p>
                                </td>
                            </tr>

                            <tr>
                                <td class="odd">
                                    <h5>Verificação de Plágio iThenticate</h5>
                                    <p>
                                        Obtenha a mais alta qualidade de verificação de plágio contra fontes da Internet, publicações pagas e de Acesso Aberto, powered by iThenticate.
                                    </p>
                                </td>
                                <td class="odd">
                                    <p class="text-center" style="font-size: 16px;">18 créditos por relatório
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <h5>Edição automática do arquivo</h5>
                                    <p>Edite automaticamente arquivos do MS Word em minutos e baixe um arquivo alterado rastreado
                                        com todas as alterações.
                                    </p>
                                </td>
                                <td>
                                    <p class="text-center" style="font-size: 16px;">1 crédito para cada 5.000 palavras do arquivo
                                    </p>
                                </td>
                            </tr>

                            <tr>
                                <td class="odd">
                                    <h5>Verificações de prontidão para publicação</h5>
                                    <p>Avalia seu documento quanto à prontidão para publicação em relação a mais de 20 pontos
                                        de verificação - seleção de periódicos, conformidade ética e muito mais.

                                    </p>
                                </td>
                                <td class="odd">
                                    <p class="text-center" style="font-size: 16px;">1 crédito para cada registro
                                    </p>
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <h5>Verificador de Citações </h5>
                                    <p>Idenfique citações que podem enfraquecer sua premissa de pesquisa e sua argumentação, e faça citações com credibilidade e autoridade no seu artigo.</p>
                                </td>
                                <td>
                                    <p class="text-center" style="font-size: 16px;">1 crédito para até 10 citações
                                    </p>
                                </td>
                            </tr>

                            <!-- <tr>
                                <td>
                                    <h5>Plagiarism Checker</h5>

                                    <p>Avoid unintentional plagiarism in your content. Choose from multiple plagisrism checkers,
                                        including iThenticate.
                                    </p>
                                </td>
                                <td>
                                    <p class="text-center"  style="font-size: 16px;">Starts from 3 credits for<br />every check
                                    </p>
                                </td>
                            </tr>

                            <tr>
                                <td class="odd">
                                    <h5>Referrence Quality Check</h5>
                                    <p>Avoid using poor-quality citations and strengthen your argumentation with multiple quality
                                        checks for your reference list.
                                    </p>
                                </td>
                                <td class="odd">
                                    <p class="text-center"  style="font-size: 16px;">3 credits for every file</p>
                                </td>
                            </tr> -->

                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="creadits_availability">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="key_features_heading">
                        <h2>
                            <sup>
                                <img style="width: 22px;" src="../../../../assets/images/credits_icon.png" />
                            </sup> Disponibilidade de créditos</h2>
                        <div class="HeadingSubLine"></div>
                        <p style="margin: 0;">Todos os usuários de Trinka recebem créditos a cada 30 dias. Os créditos não utilizados expiram e
                            são redefinidos a cada 30 dias. Compre créditos adicionais quando precisar. Os créditos adquiridos
                            nunca expiram. Para saber mais sobre os pacotes de crédito,
                            <a (click)="scroll(target)" style="cursor: pointer;">clique aqui</a>.
                        </p>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="creaditsCardSection first">
                        <div class="creaditsCards boxShadowNone">
                            <div class="creaditsBoxHeader">
                                <h2>Basic</h2>
                                <span>Usuários Gratuitos</span>
                            </div>
                            <div class="creaditsToggleButton">
                                <h3>4</h3>
                                <p>(créditos gratuitos a cada 30 dias)</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="creaditsCardSection">
                        <div class="creaditsCards boxShadowNone">
                            <div class="creaditsBoxHeader">
                                <h2>Premium</h2>
                                <span>Usuários Pagantes</span>
                            </div>
                            <div class="creaditsToggleButton">
                                <h3>10</h3>
                                <p>(créditos gratuitos a cada 30 dias)</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="how_it_works">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="key_features_heading">
                        <h2>Como funciona</h2>
                        <div class="HeadingSubLine"></div>
                        <p style="margin-bottom: 30px;">Vamos considerar um caso de uso de um indivíduo que está em um plano Básico e se registrou no dia
                            5 de janeiro.
                        </p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="credit_case">
                        <div class="table table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th style="text-decoration: underline;" colspan="5">Case 1</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style="font-weight: 600; background-color: #f8f6f9;">Date</td>
                                        <td style="font-weight: 600; background-color: #f8f6f9;">Particulars</td>
                                        <td style="font-weight: 600; background-color: #f8f6f9;">Debit</td>
                                        <td style="font-weight: 600; background-color: #f8f6f9;">Credit</td>
                                        <td style="font-weight: 600; background-color: #f8f6f9;">Balance</td>
                                    </tr>
                                    <tr>
                                        <td>05-Jan</td>
                                        <td>Abrindo Saldo de Crédito Gratuito</td>
                                        <td></td>
                                        <td></td>
                                        <td>4</td>
                                    </tr>
                                    <tr>
                                        <td>10-Jan</td>
                                        <td>Usou 1 crédito para Edição Automática do Arquivo</td>
                                        <td style="color: red;">-1</td>
                                        <td></td>
                                        <td>3</td>
                                    </tr>
                                    <tr>
                                        <td>05-Feb</td>
                                        <td>Redefinição de Saldo de Crédito Gratuito</td>
                                        <td style="color: red;"></td>
                                        <td style="color: green;">+4</td>
                                        <td>4</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="credit_case">
                        <div class="table table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th style="text-decoration: underline;" colspan="5">Case 2</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style="font-weight: 600; background-color: #f8f6f9;">Date</td>
                                        <td style="font-weight: 600; background-color: #f8f6f9;">Particulars</td>
                                        <td style="font-weight: 600; background-color: #f8f6f9;">Debit</td>
                                        <td style="font-weight: 600; background-color: #f8f6f9;">Credit</td>
                                        <td style="font-weight: 600; background-color: #f8f6f9;">Balance</td>
                                    </tr>
                                    <tr>
                                        <td>05-Jan</td>
                                        <td>Abrindo Saldo de Crédito Gratuito</td>
                                        <td></td>
                                        <td></td>
                                        <td>4</td>
                                    </tr>
                                    <tr>
                                        <td>10-Jan</td>
                                        <td>Usou 2 créditos para Edição Automática do Arquivo</td>
                                        <td style="color: red;">-2</td>
                                        <td></td>
                                        <td>2</td>
                                    </tr>
                                    <tr>
                                        <td>25-Jan</td>
                                        <td>Pacote de 4 Créditos adquirido</td>
                                        <td></td>
                                        <td style="color: green;">+2</td>
                                        <td>4</td>
                                    </tr>
                                    <tr>
                                        <td>05-Feb</td>
                                        <td>Redefinição de Saldo de Crédito Gratuito (2 Gratuitos + 4 Pagos)</td>
                                        <td></td>
                                        <td style="color: green;">+4</td>
                                        <td>6</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="credit_case">
                        <div class="table table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th style="text-decoration: underline;" colspan="5">Case 3</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style="font-weight: 600; background-color: #f8f6f9;">Date</td>
                                        <td style="font-weight: 600; background-color: #f8f6f9;">Particulars</td>
                                        <td style="font-weight: 600; background-color: #f8f6f9;">Debit</td>
                                        <td style="font-weight: 600; background-color: #f8f6f9;">Credit</td>
                                        <td style="font-weight: 600; background-color: #f8f6f9;">Balance</td>
                                    </tr>
                                    <tr>
                                        <td>05-Jan</td>
                                        <td>Abrindo Saldo de Crédito Gratuito</td>
                                        <td></td>
                                        <td></td>
                                        <td>10</td>
                                    </tr>
                                    <tr>
                                        <td>10-Jan</td>
                                        <td>Pacote de 4 Créditos adquirido</td>
                                        <td></td>
                                        <td style="color: green;">+2</td>
                                        <td>12</td>
                                    </tr>
                                    <tr>
                                        <td>25-Jan</td>
                                        <td>Usou 4 créditos para Edição Automática do Arquivo</td>
                                        <td style="color: red;">-4</td>
                                        <td></td>
                                        <td>8</td>
                                    </tr>
                                    <tr>
                                        <td>05-Feb</td>
                                        <td>Redefinição de Saldo de Crédito Gratuito (2 Gratuitos + 2 pago)</td>
                                        <td></td>
                                        <td style="color: green;">+10</td>
                                        <td>12</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="credit_balance">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="key_features_heading">
                        <h2>
                            <sup class="">
                                <img style="width: 22px;margin-right: 5px;" src="../../../../assets/images/credits_icon.png" />
                            </sup>Balanço de crédito
                        </h2>
                        <div class="HeadingSubLine"></div>

                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="credit_balance_wrapper">
                        <div class="credit_balance_inner">
                            <img src="../../../../assets/images/credits-banner1.png" class="img-fluid" />
                        </div>
                        <div class="credit_balance_text">
                            <div class="credit_table">
                                <h3>Verifique seu saldo de créditos e adquira créditos</h3>
                                <p>Seu saldo de crédito é mostrado em todas as páginas relevantes. Clicar no valor permite ver
                                    mais detalhes e comprar mais créditos.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="credit_balance_wrapper">
                        <div class="credit_balance_inner">
                            <img src="../../../../assets/images/credits-banner2.png" class="img-fluid" />
                        </div>
                        <div class="credit_balance_text">
                            <div class="credit_table">
                                <h3>Créditos necessários para usar recursos do Trinka</h3>
                                <p>Quando você usa um recurso baseado em crédito, o número de créditos necessários para usar
                                    esse recurso será exibido para você antes de usá-lo.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="buying-credit" #target>
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="use_trinka_heading">
                        <div class="howItWorkHeading lineWhiteColor">
                            <!-- <span class="">
                                <img src="../../../../assets/images/credits_icon.png" />
                            </span> -->
                            <h2>Adquirindo Créditos</h2>
                            <div class="HeadingSubLine"></div>
                            <p style="margin: 0;">Você pode adquirir pacotes de crédito sempre que precisar. Os pacotes de crédito permitem que
                                você adquira vários créditos de uma vez e os use a qualquer momento. Os creditos adquiridos
                                nunca expiram. Você também ganha ótimos descontos! Melhor ainda, os créditos gratuitos são
                                sempre usados primeiro automaticamente!</p>
                        </div>
                    </div>
                    <div class="credit_pack">
                        <div class="buyCreditTable table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th style="font-size: 24px;color: #000000; font-weight: bold;">Credit Packs</th>
                                        <th style="font-size: 24px;color: #000000; font-weight: bold;">
                                            <span>Basic</span>
                                            <br />
                                            <!-- <span class="comingSoonText">(Credit purchase will be available soon)</span> -->
                                        </th>
                                        <th style="font-size: 24px;color: #000000; font-weight: bold;">Premium</th>
                                    </tr>
                                </thead>
                                <tr>
                                    <td style="font-size: 20px;color: #4d4d4d; font-weight: 600;">Free monthly Credits</td>
                                    <td>4</td>
                                    <td>10</td>
                                </tr>
                                <tr>
                                    <td style="font-size: 20px;color: #4d4d4d; font-weight: 600;">{{decodedData[0].text}}</td>
                                    <td>{{decodedData[0].currency}} {{decodedData[0].final_amount / 2 | number:'1.2-2'}} <i>per credit</i></td>
                                    <td>
                                        <div class="credit_info">
                                            <span class="strikethrough">{{decodedData[0].currency_code}}{{decodedData[0].final_amount / 2}}</span>
                                            <sup style="font-size: 13px;">{{decodedData[0].currency_code}}</sup> {{calculatePlan(premiumDecodedData[0].final_amount, premiumDecodedData[0].months)}}
                                            <span class="yellow-btn">~{{calculateDiscountFinal(decodedData[0].final_amount/2,decodedData[3].final_amount, decodedData[3].months)}}% off</span>
                                            <i>{{premiumDecodedData[0].amount_suffix}}</i>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td style="font-size: 20px;color: #4d4d4d; font-weight: 600;">{{decodedData[1].text}}</td>
                                    <td>
                                        <div class="credit_info">
                                            <span class="strikethrough">{{decodedData[1].currency_code}}{{decodedData[0].final_amount / 2}}</span>
                                            <sup style="font-size: 13px;">{{decodedData[1].currency_code}}</sup> {{calculatePlan(decodedData[1].final_amount, decodedData[1].months)}}
                                            <span class="yellow-btn">~{{calculateDiscountFinal(decodedData[0].final_amount/2,decodedData[1].final_amount, decodedData[1].months)}}% off</span>
                                            <i>{{decodedData[1].amount_suffix}}</i>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="credit_info">
                                            <span class="strikethrough">{{decodedData[1].currency_code}}{{decodedData[0].final_amount / 2}}</span>
                                            <sup style="font-size: 13px;">{{premiumDecodedData[1].currency_code}}</sup> {{calculatePlan(premiumDecodedData[1].final_amount, premiumDecodedData[1].months)}}
                                            <span class="yellow-btn">~{{calculateDiscountFinal(decodedData[0].final_amount/2,premiumDecodedData[1].final_amount, premiumDecodedData[1].months)}}% off</span>
                                            <i>{{premiumDecodedData[1].amount_suffix}}</i>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td style="font-size: 20px;color: #4d4d4d; font-weight: 600;">{{decodedData[2].text}}</td>
                                    <td>
                                        <div class="credit_info">
                                            <span class="strikethrough">{{decodedData[2].currency_code}}{{decodedData[0].final_amount / 2}}</span>
                                            <sup style="font-size: 13px;">{{decodedData[2].currency_code}}</sup> {{calculatePlan(decodedData[2].final_amount, premiumDecodedData[2].months)}}
                                            <span class="yellow-btn">~{{calculateDiscountFinal(decodedData[0].final_amount/2,decodedData[2].final_amount, decodedData[2].months)}}% off</span>
                                            <i>{{decodedData[2].amount_suffix}}</i>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="credit_info">
                                            <span class="strikethrough">{{decodedData[2].currency_code}}{{decodedData[0].final_amount / 2}}</span>
                                            <sup style="font-size: 13px;">{{premiumDecodedData[2].currency_code}}</sup> {{calculatePlan(premiumDecodedData[2].final_amount, premiumDecodedData[2].months)}}
                                            <span class="yellow-btn">~{{calculateDiscountFinal(decodedData[0].final_amount/2,premiumDecodedData[2].final_amount, premiumDecodedData[2].months)}}% off</span>
                                            <i>{{premiumDecodedData[2].amount_suffix}}</i>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td style="font-size: 20px;color: #4d4d4d; font-weight: 600;">{{decodedData[3].text}}</td>
                                    <td>
                                        <div class="credit_info">
                                            <span class="strikethrough">{{decodedData[3].currency_code}}{{decodedData[0].final_amount / 2}}</span>
                                            <sup style="font-size: 13px;">{{decodedData[3].currency_code}}</sup> {{calculatePlan(decodedData[3].final_amount, premiumDecodedData[3].months)}}
                                            <span class="yellow-btn">~{{calculateDiscountFinal(decodedData[0].final_amount/2,decodedData[3].final_amount, decodedData[3].months)}}% off</span>
                                            <i>{{decodedData[3].amount_suffix}}</i>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="credit_info">
                                            <span class="strikethrough">{{decodedData[3].currency_code}}{{decodedData[0].final_amount / 2}}</span>
                                            <sup style="font-size: 13px;">{{premiumDecodedData[3].currency_code}}</sup> {{calculatePlan(premiumDecodedData[3].final_amount, premiumDecodedData[3].months)}}
                                            <span class="yellow-btn">~{{calculateDiscountFinal(decodedData[0].final_amount/2,premiumDecodedData[3].final_amount, premiumDecodedData[3].months)}}% off</span>
                                            <i>{{premiumDecodedData[3].amount_suffix}}</i>
                                        </div>
                                    </td>
                                </tr>
                                <!-- <tr *ngFor="let planMode of paymentModeOption;let i = index;">
                                    <td style="font-size: 20px;color: #4d4d4d; font-weight: 600;">{{planMode.text}}</td>
                                    <td>{{planMode.currency}}{{planMode.final_amount| number:'1.2-2'}}</td>
                                    <td> {{planMode.currency}}{{calculatePlan(planMode.final_amount, planMode.months)}}
                                        <span class="yellow-btn">~{{calculateDiscount(planMode.amount,planMode.final_amount, planMode.months)}}%</span>
                                        <i>{{planMode.amount_suffix}}</i></td>
                                </tr> -->
                                
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="use_trinka_other_app">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="use_trinka_content">
                        <div class="use_trinka_heading">
                            <div class="howItWorkHeading lineWhiteColor">
                                <h2>Créditos para equipes e empresas</h2>
                                <!-- <div class="HeadingSubLine"></div> -->
                            </div>
                        </div>
                        <div class="others_app_name">
                            <p>Os planos Enterprise da Trinka permitem comprar créditos para cada equipe ou para a organização,
                                conforme sua necessidade. Os planos Enterprise também permitem distribuição de crédito flexível
                                e compras de crédito em massa.
                            </p>
                            <a routerLink='/enterprise'>Contate-nos</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="pricingQuestionAnwser" #target>
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="pricingHeadingQuestion">
                        <h2>Perguntas feitas frequentemente</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
                <div class="col-lg-10">
                    <div class="pricingQuestionsList">
                        <div class="accordion" id="faq">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        As compras a crédito são reembolsáveis?</a>
                                </div>

                                <div id="QuestionOneContent" class="collapse show" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>As compras a crédito não podem ser reembolsadas. Os créditos adquiridos permanecem
                                            com você até que você os use.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">O que acontece com os meus créditos gratuitos se eu fizer upgrade para Premium?</a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Ao atualizar para Premium, seu saldo de crédito será redefinido para 10, independentemente
                                            dos créditos gratuitos não utilizados.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        O que acontece com os meus créditos adquiridos se eu fizer upgrade para Premium?
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Seus créditos adquiridos permanecem com você quando você fizer o upgrade e você poderá
                                            usá-los sempre que quiser.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        Existe um limite para compras a crédito?
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Você pode adquirir quantos créditos quiser, não há limite de compras a crédito.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="card">
                                <div class="card-header" id="QuestionFive">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFiveContent" aria-expanded="true"
                                        aria-controls="QuestionFiveContent">
                                        Obtenha a flexibilidade de usar os recursos do Trinka com Créditos
                                    </a>
                                </div>

                                <div id="QuestionFiveContent" class="collapse" aria-labelledby="QuestionFive" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Muitos recursos adicionais do Trinka consomem créditos. Você pode utilizar esses
                                            créditos para usar esses recursos e adquirir mais créditos conforme necessário.
                                        </p>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
            </div>
        </div>
    </div>

</div>

<!-- Modal -->
<div class="modal fade" id="wordPluginPopup" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/5KsBh4PQUPI"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <!-- <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/z-TVcRwVp3A"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe> -->
            </div>
        </div>
    </div>
</div>